'use strict';

var App = require('app');
var Types = require('consts').HeatCharacteristicTypes;
var CharacteristicView = require('components/devices/views/controller/characteristic_view');
var ConstantView = require('components/devices/views/controller/constant_view');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Notification = require('utils/notification');

var backTemp = 'backFlowTemperature';
var dayTemp = 'flowTemperatureDay';
var nightTemp = 'flowTemperatureNight';
var outTemp = 'outdoorTemperature';

var ParameterDialogView = Backbone.Marionette.LayoutView.extend({
    template: require('components/devices/templates/controller/parameter_dialog'),
    regions: {
        parameter: '#js-parameter-region',
    },

    ui: {
        save: '#js-save',
        type: 'div.js-parameter-type',
    },

    events: {
        'click @ui.save': 'save',
        'change @ui.type': 'changeType',
    },

    initialize: function (options) {
        this.circuit = options.circuit;
        this.values = options.values;
        this.graphType = this.values.getType();
        this.oldGraphType = this.graphType;
        this.totalCircuits = options.totalCircuits;
        this.values.set('flowType', dayTemp);
        // graph types
        this.graphTypes = {};
        this.graphTypes[Types.ConstantValue] = {
            name: i18n.TR('Festwertregelung'),
            selected: this.graphType === Types.ConstantValue,
        };
        this.graphTypes[Types.FourPoint] = {
            name: i18n.TR('4-Punkte-Kennlinie'),
            selected: this.graphType === Types.FourPoint,
        };
        this.graphTypes[Types.Gradient] = {
            name: i18n.TR('Steigungskennlinie'),
            selected: this.graphType === Types.Gradient,
        };
    },

    serializeData: function () {
        return {
            types: this.graphTypes,
            graphType: this.graphType,
            flowType: this.values.get('flowType'),
            title: this.graphTypes[this.graphType].name,
            circuit: this.circuit,
            showWarning: this.showWarning,
        };
    },

    onRender: function () {
        var options = { values: this.values, readOnly: false, circuitNr: this.options.circuitNr };
        var view = new CharacteristicView(options);
        if (this.values.getType() === Types.ConstantValue) {
            view = new ConstantView(options);
        }
        this.showChildView('parameter', view);
        Misc.initSelectPicker();
    },

    onShow: function () {
        if (this.values.getType() !== Types.ConstantValue) {
            $('.modal-dialog').addClass('modal-lg');
        }
        Misc.initSelectPicker();
    },

    onBeforeDestroy: function () {
        if (this.values.getType() !== Types.ConstantValue) {
            $('.modal-dialog').removeClass('modal-lg');
        }
    },

    changeType: function (e) {
        this.graphType = parseInt(e.target.value);
        this.showWarning =
            !Misc.isFirmwareSufficient(this.options.firmware, '2.50') &&
            this.totalCircuits > 1 &&
            // switched to or from constant value setting
            (this.oldGraphType === Types.ConstantValue) != (this.graphType === Types.ConstantValue);

        this.values.setType(this.graphType);
        // night flow for the gradient charactieristic is not editable -> change to day
        if (this.values.get('flowType') === nightTemp) {
            this.values.set('flowType', dayTemp);
        }
        if (this.values.getType() !== Types.ConstantValue) {
            $('.modal-dialog').addClass('modal-lg');
        } else {
            $('.modal-dialog').removeClass('modal-lg');
        }
        this.render();
    },

    save: function () {
        var parameter = this.getChildView('parameter').getValues(this.circuit.get('circuitNr'));
        var req = App.request('device:set:parameter', this.options.deviceID, parameter);
        var self = this;
        $.when(req).done(function (resp) {
            if (resp === false) {
                Notification.show(
                    'error',
                    i18n.TR('Fehler'),
                    i18n.TR('Einstellungen konnten nicht gespeichert werden.')
                );
            } else {
                Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Einstellungen wurden gespeichert.'));
                self.options.callback();
            }
        });
    },
});

module.exports = ParameterDialogView;
